parasails.registerPage('qr-display', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    backgroundStyleFIXED: 'position: fixed; display: flex; width: 100%; height: 100%;',
    backgroundStyle: '',
    QRCodeDestination: '',
    QRCodeSize: 1024
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    var newDestination = this.eventData.panelData.destination + "?eventID=" + this.eventData.overallEventID;
    console.log("Setting destination to " + newDestination);
    this.QRCodeDestination = this.eventData.panelData.destination + "?eventID=" + this.eventData.overallEventID;
    this.backgroundStyle = this.backgroundStyleFIXED;
    this.setBGStyle();
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    setDestination() {
      if(this.eventData.panelData && this.eventData.panelData.destination) {
        this.QRCodeDestination = this.eventData.panelData.destination + "?eventID=" + this.eventData.overallEventID;
      }
    },
    setBGStyle() {
      var bgImage = '../images/Visibby汎用BG.png';

      if(this.eventData.panelData && this.eventData.panelData.bg) {
        bgImage = this.eventData.panelData.bg;
        if(bgImage === '') {
          bgImage = '../images/Visibby汎用BG.png';
        } else {
          if(bgImage.startsWith('#') === true) {
            this.backgroundStyle = this.backgroundStyleFIXED + ' background-color: ' + bgImage.toLowerCase() + ' !important;';
          } else {
            this.backgroundStyle = 'background-image: url(\'' + bgImage + '\') !important; ' + this.backgroundStyleFIXED;
          }
        }
      }
    },
  }
});
